/**
 * @date: 3/16/22
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useEffect, useState} from "react";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {getActiveBatchProgressById} from "../ExternalSourceManagement/ExternalSourceBatchProcess";
import {addTaxonomyBatch} from "../features/taxonomyBatchSlice";
import {addNpiBatch} from "../features/npiBatchSlice";
import {Box, IconButton, LinearProgress, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import LinearWithValueLabel from "../utils/LinearProgressWithLabel";

const BatchStatus = {
    Init: 'Init',
    Running: 'Running',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Interrupted: 'Interrupted'
}
export default function BatchProcess(props) {
    const id = props.match.params.id || props.id || 0;
    const [task, setTask] = useState(null);
    console.log('BatchProcess', props);
    useEffect(() => {
        const timer = setInterval(() => {
            if (task.status.current === BatchStatus.Init || task.status.current === BatchStatus.Running){
                fetchData(id);
            }
        }, 750)
        return () => {
            clearInterval(timer);
        }
    }, [id]);
    const fetchData = async (id) => {
        console.log('fatching ', id)
        fetch(ApiUrl.Batch.getBatchById.getPath(id))
            .then(handleHttpResponse)
            .catch( (err) => {
                if (err) {
                    console.error("Failed to fetch all active batch, " + err);
                }
            })
            .then( res => {
                if (res) {
                    setTask(res);
                }
            })
    }


    return (<Box sx={{ display: 'flex', alignItems: 'center' }}>
        <LinearWithValueLabel progress={task.progress} />
    </Box>)
}
